import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { FormButtons, renderers, validations } from '../../components'
const LoginFormMarkup = ({ handleSubmit, pristine, reset, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="email"
        type="email"
        component={renderers.renderField}
        label="Email"
        validate={[validations.required, validations.email]}
      />
      <Field
        name="password"
        type="password"
        component={renderers.renderField}
        label="Password"
        validate={[validations.required]}
      />
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
const LoginForm = reduxForm({
  form: 'LoginForm',
})(LoginFormMarkup)

export default LoginForm
